import * as React from 'react';
import { Container } from '../../semantic';
import { withNamespaces, WithNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { BackButton } from '../common';
import { addAccessibilityMessage, setProvider } from '../../actions/app';
import { IAppState } from '../../reducers';
import { HeadTitle } from '../HeadTitle';
import { Heading } from '../Heading';
import { IAddress, saveApplication } from '../../actions/api';
import { Language } from '../../typings/Language';

interface IStateProps {
  pin?: string;
  address?: IAddress;
  locale: Language;
}

interface IDispatchProps {
  addAccessibilityMessage: typeof addAccessibilityMessage;
  saveApplication: typeof saveApplication;
  setProvider: typeof setProvider;
}

type Props = IStateProps & IDispatchProps & WithNamespaces;

class Component extends React.Component<Props> {
  public componentDidMount() {
    this.props.addAccessibilityMessage(this.props.t('aria.messages.noIsps'));

    if (this.props.pin && this.props.address) {
      this.props.setProvider('noIsp');
      this.props.saveApplication();
    }
  }

  public render() {
    const { props } = this;

    return (
      <Container text={true}>
        <HeadTitle title={props.t('screens.noIsps.title')} />
        <BackButton />
        <div>
          <Heading>{props.t('screens.noIsps.heading')}</Heading>
          <p>{props.t('screens.noIsps.paragraph1')}</p>
        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => {
  return {
    locale: state.locale,
    pin: state.pin,
    address: state.mailingAddress,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => {
  return bindActionCreators(
    { addAccessibilityMessage, saveApplication, setProvider },
    dispatch
  );
};

export const NoIsps = withNamespaces()(
  connect<{}, IDispatchProps, {}, IAppState>(
    mapStateToProps,
    mapDispatchToProps
  )(Component)
);
